import { Union } from "../fable_modules/fable-library-js.4.25.0/Types.js";
import { lambda_type, union_type, string_type } from "../fable_modules/fable-library-js.4.25.0/Reflection.js";
import { isNullOrWhiteSpace, printf, toText } from "../fable_modules/fable-library-js.4.25.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.25.0/Result.js";
import { Result_map, Result_bind } from "../fable_modules/AsyncResult.0.3.0/Result.fs.js";
import { uncurry2, curry2 } from "../fable_modules/fable-library-js.4.25.0/Util.js";
import { map, some, value } from "../fable_modules/fable-library-js.4.25.0/Option.js";
import { DateTimeOffset_truncateToMicrosecond } from "../fable_modules/Webbler.Models.1.3.1/Extensions.fs.js";
import { equals, compare } from "../fable_modules/fable-library-js.4.25.0/Date.js";
import { date, utcNow } from "../fable_modules/fable-library-js.4.25.0/DateOffset.js";
import { isEmpty } from "../fable_modules/fable-library-js.4.25.0/List.js";

export class FormValidationError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["InvalidValue", "NotNullOrEmpty", "MandatoryNotSet"];
    }
}

export function FormValidationError_$reflection() {
    return union_type("ThreeDocs.SharedUI.FormValidation.FormValidationError", [], FormValidationError, () => [[["fieldName", string_type], ["must", string_type]], [["fieldName", string_type]], [["fieldName", string_type]]]);
}

export function FormValidationError_get_describe() {
    return (_arg) => ((_arg.tag === 1) ? toText(printf("%s must not be null or empty"))(_arg.fields[0]) : ((_arg.tag === 2) ? toText(printf("%s is a required value."))(_arg.fields[0]) : toText(printf("%s must %s"))(_arg.fields[0])(_arg.fields[1])));
}

export class FieldValidity extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Valid", "Invalid"];
    }
}

export function FieldValidity_$reflection() {
    return union_type("ThreeDocs.SharedUI.FormValidation.FieldValidity", [], FieldValidity, () => [[], [["Item", FormValidationError_$reflection()]]]);
}

export function FieldValidity_ofResult_Z22DD7A26(result) {
    if (result.tag === 1) {
        return new FieldValidity(1, [result.fields[0]]);
    }
    else {
        return new FieldValidity(0, []);
    }
}

export function FieldValidity_get_describe() {
    return (_arg) => ((_arg.tag === 1) ? FormValidationError_get_describe()(_arg.fields[0]) : "Valid");
}

export class ValidatedSetter$2 extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ValidatedSetter"];
    }
}

export function ValidatedSetter$2_$reflection(gen0, gen1) {
    return union_type("ThreeDocs.SharedUI.FormValidation.ValidatedSetter`2", [gen0, gen1], ValidatedSetter$2, () => [[["Item", lambda_type(gen0, union_type("Microsoft.FSharp.Core.FSharpResult`2", [lambda_type(gen1, gen1), FormValidationError_$reflection()], FSharpResult$2, () => [[["ResultValue", lambda_type(gen1, gen1)]], [["ErrorValue", FormValidationError_$reflection()]]]))]]]);
}

export function Operators_op_GreaterEqualsGreater(val1, val2) {
    return (fieldName) => ((field) => {
        const val2_1 = val2;
        const fieldName_1 = fieldName;
        const result1 = val1(fieldName_1, field);
        return Result_bind()(curry2(val2_1)(fieldName_1))(result1);
    });
}

export function Operators_op_QmarkEqualsQmark(val1, val2) {
    return (fieldName) => ((field) => {
        const val1_1 = val1;
        const val2_1 = val2;
        const fieldName_1 = fieldName;
        const field_1 = field;
        if (field_1 == null) {
            return new FSharpResult$2(0, [undefined]);
        }
        else {
            const result1 = val1_1(fieldName_1, value(field_1));
            return Result_map()(some)(Result_bind()(curry2(val2_1)(fieldName_1))(result1));
        }
    });
}

export function Validate_required(fieldName, field) {
    if (field == null) {
        return new FSharpResult$2(1, [new FormValidationError(2, [fieldName])]);
    }
    else {
        return new FSharpResult$2(0, [value(field)]);
    }
}

export function Validate_String_trim(_fieldName, field) {
    return new FSharpResult$2(0, [map((str) => str.trim(), field)]);
}

export function Validate_String_notNullOrWhiteSpace(fieldName, field) {
    if (field == null) {
        return new FSharpResult$2(0, [undefined]);
    }
    else if (!isNullOrWhiteSpace(field)) {
        const str_1 = field;
        return new FSharpResult$2(0, [str_1]);
    }
    else {
        return new FSharpResult$2(1, [new FormValidationError(1, [fieldName])]);
    }
}

export const Validate_String_standardValidate = Operators_op_GreaterEqualsGreater(Validate_String_notNullOrWhiteSpace, Validate_String_trim);

export function Validate_String_notLongerThan(maxLength, fieldName, field) {
    let tupledArg, str;
    let matchResult, str_1;
    if (field != null) {
        if ((str = field, str.length > maxLength)) {
            matchResult = 0;
            str_1 = field;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new FSharpResult$2(1, [(tupledArg = [fieldName, `not be longer than ${maxLength} characters`], new FormValidationError(0, [tupledArg[0], tupledArg[1]]))]);
        default:
            return new FSharpResult$2(0, [field]);
    }
}

export function Validate_Guid_notNullEmpty(fieldName, field) {
    if (field === "00000000-0000-0000-0000-000000000000") {
        return new FSharpResult$2(1, [new FormValidationError(1, [fieldName])]);
    }
    else {
        return new FSharpResult$2(0, [field]);
    }
}

export function Validate_DateTimeOffset_truncate(_fieldName, field) {
    return new FSharpResult$2(0, [map(DateTimeOffset_truncateToMicrosecond, field)]);
}

export function Validate_DateTimeOffset_notFutureDate(fieldName, field) {
    let matchResult, dateTime_1;
    if (field == null) {
        matchResult = 1;
    }
    else if (compare(field, utcNow()) > 0) {
        matchResult = 0;
        dateTime_1 = field;
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new FSharpResult$2(1, [new FormValidationError(0, [fieldName, "not be in the future"])]);
        default:
            return new FSharpResult$2(0, [field]);
    }
}

export const Validate_DateTimeOffset_isToday_ = (() => {
    const nowTime = utcNow();
    return (fieldName) => ((field) => {
        let dateTime_1;
        return (field == null) ? (new FSharpResult$2(0, [field])) : (!equals(date(field), date(nowTime)) ? ((dateTime_1 = field, new FSharpResult$2(1, [new FormValidationError(0, [fieldName, "be the current date"])]))) : (new FSharpResult$2(0, [field])));
    });
})();

export function Validate_DateTimeOffset_notPastDate_(fieldName, field) {
    let matchResult, dateTime_1;
    if (field == null) {
        matchResult = 1;
    }
    else if (compare(field, utcNow()) < 0) {
        matchResult = 0;
        dateTime_1 = field;
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new FSharpResult$2(1, [new FormValidationError(0, [fieldName, "not be in the past"])]);
        default:
            return new FSharpResult$2(0, [field]);
    }
}

export const Validate_DateTimeOffset_notPastDate = Operators_op_GreaterEqualsGreater(Validate_DateTimeOffset_truncate, Validate_DateTimeOffset_notPastDate_);

export const Validate_DateTimeOffset_isToday = Operators_op_GreaterEqualsGreater(Validate_DateTimeOffset_truncate, uncurry2(Validate_DateTimeOffset_isToday_));

export const Validate_DateTimeOffset_standardValidate = Operators_op_GreaterEqualsGreater(Validate_DateTimeOffset_truncate, Validate_DateTimeOffset_notFutureDate);

export function Validate_List_required(fieldName, field) {
    if (isEmpty(field)) {
        return new FSharpResult$2(1, [new FormValidationError(2, [fieldName])]);
    }
    else {
        return new FSharpResult$2(0, [field]);
    }
}

